import { c as _c } from "react/compiler-runtime";
import { HttpTypes } from "@medusajs/types";
import { clx } from "@medusajs/ui";
import React from "react";
type OptionSelectProps = {
  option: HttpTypes.StoreProductOption;
  current: string | undefined;
  updateOption: (title: string, value: string) => void;
  title: string;
  disabled: boolean;
  disabledValues?: string[];
  "data-testid"?: string;
};
const OptionSelect: React.FC<OptionSelectProps> = t0 => {
  const $ = _c(31);
  const {
    option,
    current,
    updateOption,
    title,
    disabled,
    disabledValues: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const disabledValues = t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== current || $[3] !== disabled || $[4] !== disabledValues || $[5] !== option || $[6] !== title || $[7] !== updateOption) {
    const filteredOptions = (option.values ?? []).map(_temp).filter(Boolean) as string[];
    const optKey = (option as any).name || (option as any).title || (option as any).id || (option as any)._id || title;
    t7 = "flex items-center gap-3";
    if ($[14] !== title) {
      t8 = <span className="text-black text-sm font-lealti">{title}</span>;
      $[14] = title;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t3 = "radiogroup";
    t4 = String(title);
    t5 = "flex flex-wrap gap-2";
    let t9;
    if ($[16] !== current || $[17] !== disabled || $[18] !== disabledValues || $[19] !== optKey || $[20] !== updateOption) {
      t9 = v_0 => {
        const isDisabled = disabled || disabledValues.includes(v_0);
        const isSelected = current === v_0;
        return <button key={v_0} type="button" role="radio" aria-checked={isSelected} disabled={isDisabled} onClick={() => {
          if (isDisabled) {
            return;
          }
          updateOption(String(optKey), v_0);
        }} onKeyDown={e => {
          if (isDisabled) {
            return;
          }
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            updateOption(String(optKey), v_0);
          }
        }} className={clx("inline-flex items-center justify-center text-sm px-3 py-2 border transition-colors duration-150 font-lealti-light rounded-3xl", {
          "bg-black text-white border-black": isSelected,
          "border-white text-black": !isSelected,
          "opacity-50 cursor-not-allowed line-through": isDisabled
        })}>{v_0}</button>;
      };
      $[16] = current;
      $[17] = disabled;
      $[18] = disabledValues;
      $[19] = optKey;
      $[20] = updateOption;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t6 = filteredOptions.map(t9);
    $[2] = current;
    $[3] = disabled;
    $[4] = disabledValues;
    $[5] = option;
    $[6] = title;
    $[7] = updateOption;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t9 = <div role={t3} aria-label={t4} className={t5}>{t6}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
export default OptionSelect;
function _temp(v) {
  return typeof v === "string" ? v : v?.value;
}